import { cn } from '@creator/ui/utils/ui';
// OffCanvasMenuClose.tsx
import type React from 'react';
import { type MouseEvent, useContext } from 'react';
import { OffCanvasMenuContext } from './OffCanvasMenu';

export interface OffCanvasMenuCloseProps {
    children?: React.ReactNode;
    className?: string;
    onClick?: () => void;
}

/**
 * A button component that closes the off‑canvas menu when clicked.
 * If no children are provided, it defaults to displaying an "×" symbol.
 */
export const OffCanvasMenuClose: React.FC<OffCanvasMenuCloseProps> = props => {
    const { children, className, onClick } = props;
    const context = useContext(OffCanvasMenuContext);

    if (!context) throw new Error('OffCanvasMenuClose must be used within an OffCanvasMenu component.');

    const { setOpen } = context;

    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        if (onClick) onClick();
        setOpen(false);
    };

    return (
        <button
            type="button"
            className={cn('transition absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300', className)}
            onClick={handleClick}
        >
            {children ? children : <span>&times;</span>}
        </button>
    );
};
